export default __webpack_public_path__ + "33279b1ea901921bbce0d509e066c78f.svg";